<div class="alarm_screen">
  <div class="alarm_container">
    <div class="alarm_header">
      <h4>Launch Instances</h4>
    </div>
    <div class="alarm_body">
      <div class="row">
        There are {{ os.length }} similar instances. Do you want to launch all instances at once?
      </div>
      <div class="alarm_actions">
        <div class="alarm_actions_11">
          <button class="btn uploading_file_12" (click)="uploadFile()">
            Launch All
          </button>
          <button class="btn btn-light" (click)="close(true)">Launch One</button>
          <button class="btn btn-light" (click)="close(false)">Cancel</button>
        </div>
      </div>
    </div>
  </div>